import React, { useEffect } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import KenButton from '../../components/KenButton';
import FinishedIcon from '../../assets/FinishedIcon.svg';
import { submitApplication, paymentReceipt , createApplication } from '../../utils/ApiService';
import { useLocation } from 'react-router-dom';
import ConfigContext from '../../utils/config';
import KenLoader from '../../components/KenLoader/KenLoader';
import payuConfig from '../../config/payuConfiguration.json';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '80vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // flex: '0 1',
  },
  title: {
    fontSize: 24,
    lineHeight: '33px',
    color: theme.palette.KenColors.neutral900,
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  sub: {
    marginTop: 12,
    fontSize: 18,
    lineHeight: '24px',
    maxWidth: 500,
    margin: '0 auto',
  },
}));

export default function ThankYouPage() {
  const { config } = React.useContext(ConfigContext);
  const [loader, setLoader] = React.useState(true);
  const query = new URLSearchParams(useLocation().search);
  const [flag, setFlag] = React.useState(false);
  //  let appId = (query.has('applicationId')) ? query.get('applicationId') : '';
  let appId = query.has('applicationId') ? query.get('applicationId') : '';
  let paymentId = query.has('razorpay_payment_id')
    ? query.get('razorpay_payment_id')
    : '';
  let status = query.has('status') ? query.get('status') : '';
  let mode = query.has('mode') ? query.get('mode') : '';
  let transactionId = query.has('transactionId')
    ? query.get('transactionId')
    : '';

  useEffect(() => {
    if (status === 'success') {
      const receiptPayload = JSON.parse(sessionStorage.getItem('receiptData'));
      receiptPayload.transId = transactionId;
      receiptPayload.paymentId = paymentId;
      receiptPayload.mode = mode;
      receiptPayload.gatewayType = payuConfig?.payuConfiguration?.paymentMethod;
      receiptPayload.applicationId = appId;
      paymentReceipt(receiptPayload)
        .then((resp) => {
          console.log('[Payment Receipt] sent successfully:', resp);
          sessionStorage.removeItem('receiptData');
        })
        .catch((error) => {
          setLoader(false);
          sessionStorage.removeItem('receiptData');
          console.log('Error [Payment Receipt]', error);
        });
      const payload = {
        records: [
          {
            attributes: {
              type: 'TP_Application__c',
              referenceId: "ref'0",
            },
            Id: appId,
            Contact__c: receiptPayload.contactID,
            Application_Status__c: 'Application Submitted',
          },
        ],
      };
      createApplication(payload)
        .then((resp) => {
          setFlag(true);
          setLoader(false);
          console.log('[Submission] submit Application:', resp);
        })
        .catch((error) => {
          setLoader(false);
          console.log('Error [Submission] submit Application:', error);
        });
    } else {
      setLoader(false);
      console.log('transaction failed');
    }
  }, [status]);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      {loader && <KenLoader />}
      <Typography className={classes.instructions}>
        <p>
          <img src={FinishedIcon}></img>
        </p>
        {flag === true ? (
          <>
            <Typography className={classes.title}>
              Application Submitted Successfully.
            </Typography>
            <Typography className={classes.sub} variant="body2">
              Your application has been submitted successfully. We will get in
              touch with you shortly. In the meantime, you can track your
              application status by logging in to this portal.
            </Typography>
          </>
        ) : (
          <>
            <Typography className={classes.title}>
              Your Transaction has failed. Please note down the following IDs
            </Typography>
            <Typography className={classes.sub} variant="body2">
              Transaction ID : {transactionId}
            </Typography>
            <Typography className={classes.sub} variant="body2">
              Application Number : {appId}
            </Typography>
          </>
        )}
        <Link className="link-plain" to="/applications">
          <KenButton style={{ marginTop: 25 }} variant="primary">
            Okay, done
          </KenButton>
        </Link>
      </Typography>
    </div>
  );
}
